import Navigation from "./Components/Navigation";
import BlogList from "./Components/BlogList";
import Footer from "./Components/Footer";
import { Provider } from "react-redux";
import store from "./Redux/store";

function App() {
	return (
		<Provider store={store}>
			<Navigation />
			<BlogList />
			<Footer />
		</Provider>
	);
}

export default App;
